<div class="distributors-form">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <h2>Ficha de Registro del Distribuidor</h2>

        <div class="field" *ngFor="let field of [
            { name: 'rfc',               label: 'RFC', requerido: '*' },
            { name: 'razon_social',      label: 'Razón Social', requerido: '*' },
            { name: 'calle',             label: 'Calle', requerido: '*' },
            { name: 'numero_exterior',   label: 'Número Exterior', requerido: '*' },
            { name: 'numero_interior',   label: 'Número Interior', requerido: '' },
            { name: 'colonia',           label: 'Colonia', requerido: '*' },
            { name: 'codigo_postal',     label: 'Código Postal', requerido: '*' },
            { name: 'municipio',         label: 'Municipio', requerido: '*' },
            { name: 'estado',            label: 'Estado', requerido: '*' },
            { name: 'nombre_contacto',   label: 'Nombre de Contacto', requerido: '*' },
            { name: 'telefono',          label: 'Teléfono Empresa', requerido: '*' },
            { name: 'telefono_contacto', label: 'Teléfono Contacto', requerido: '' },
            { name: 'correo_contacto',   label: 'Correo Contacto', requerido: '' }
            ]">

            <label [for]="field.name">{{ field.label }} {{ field.requerido }}</label>
            <input [id]="field.name" [name]="field.name" [type]="field.name.includes('correo') ? 'email' : 'text'"
                [formControlName]="field.name"
                [ngClass]="{'input-error':getControl(field.name).touched && getControl(field.name).invalid}" />

            <small class="error" *ngIf="getControl(field.name).touched && getControl(field.name).invalid">
                <span *ngIf="getControl(field.name)?.hasError('required')">
                    Campo es obligatorio
                </span>
                <span *ngIf="getControl(field.name)?.hasError('maxlength')">
                    Máximo {{getControl(field.name).getError('maxlength').requiredLength }} caracteres
                </span>
                <span *ngIf="getControl(field.name).hasError('pattern')">
                    {{ field.label }} inválido
                </span>
                <span *ngIf="getControl(field.name).hasError('email')">
                    Correo inválido
                </span>
            </small>

        </div>
        <!-- Botones -->
        <div class="buttons">
            <button type="button" class="btn btn-secondary" (click)="form.reset()">
                Cancelar
            </button>
            <button type="submit" class="btn btn-primary">
                Guardar
            </button>
        </div>

        <!--
            <button type="submit">Guardar</button>
        -->

    </form>
</div>